import { CountryState } from './reducer';
import { RootState } from '../../index';

export const selectCurrentCountry = (state: RootState): CountryState['code'] => state.public.country.code;
